/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UmbrellaFreelancerRequestStateResource } from './';
import {
    UmbrellaFreelancerRequestStateResourceFromJSON,
    UmbrellaFreelancerRequestStateResourceFromJSONTyped,
    UmbrellaFreelancerRequestStateResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface UmbrellaFreelancerHandledRequestResource
 */
export interface UmbrellaFreelancerHandledRequestResource {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaFreelancerHandledRequestResource
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof UmbrellaFreelancerHandledRequestResource
     */
    freelancerFullName: string;
    /**
     * 
     * @type {UmbrellaFreelancerRequestStateResource}
     * @memberof UmbrellaFreelancerHandledRequestResource
     */
    requestState: UmbrellaFreelancerRequestStateResource;
}

/**
 * Check if a given object implements the UmbrellaFreelancerHandledRequestResource interface.
 */
export function instanceOfUmbrellaFreelancerHandledRequestResource(value: object): value is UmbrellaFreelancerHandledRequestResource {
    if (!('freelancerFullName' in value) || value['freelancerFullName'] === undefined) return false;
    if (!('requestState' in value) || value['requestState'] === undefined) return false;
    return true;
}

export function UmbrellaFreelancerHandledRequestResourceFromJSON(json: any): UmbrellaFreelancerHandledRequestResource {
    return UmbrellaFreelancerHandledRequestResourceFromJSONTyped(json, false);
}

export function UmbrellaFreelancerHandledRequestResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaFreelancerHandledRequestResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'freelancerFullName': json['freelancerFullName'],
        'requestState': UmbrellaFreelancerRequestStateResourceFromJSON(json['requestState']),
    };
}

export function UmbrellaFreelancerHandledRequestResourceToJSON(value?: UmbrellaFreelancerHandledRequestResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'freelancerFullName': value['freelancerFullName'],
        'requestState': UmbrellaFreelancerRequestStateResourceToJSON(value['requestState']),
    };
}

